import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { PhotoLightbox } from "@/components/PhotoLightbox.jsx";
import { useMarcelMode } from "@/context/MarcelMode.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

function whenLabel(raw) {
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return String(raw).slice(0, 16);
  const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${days[d.getDay()]} · ${hh} h ${mm}`;
}

export function PhotosPage() {
  const { ui } = useOrignalUi();
  const { actingAsAdmin } = useMarcelMode();
  const [items, setItems] = useState([]);
  const [missing, setMissing] = useState([]);
  const [index, setIndex] = useState(-1);
  const [error, setError] = useState("");

  useEffect(() => {
    api("/api/prospection/album")
      .then((d) => {
        setItems(d.items || []);
        setMissing(d.missing || []);
      })
      .catch(() => {
        api("/api/media")
          .then((d) => setItems((d.items || []).filter((p) => p.kind !== "video" && p.url)))
          .catch(() => setError(ui.errors.network));
      });
  }, [ui.errors.network]);

  const gallery = items.filter((p) => p.url && p.file_ok !== false);

  return (
    <main className="og-album-page" data-testid="page-photos">
      <header className="og-panel og-album-page__head">
        <p className="og-kicker">{ui.hunt.albumName}</p>
        <h1>{ui.photos.albumTitle}</h1>
        <p>{ui.photos.albumLead}</p>
      </header>
      {error ? <p className="og-error">{error}</p> : null}
      {actingAsAdmin && missing.length ? (
        <p className="og-error" data-testid="album-missing">{missing.length} {ui.photos.missingFiles}</p>
      ) : null}
      <section className="og-album" data-testid="photo-album">
        {gallery.map((photo, i) => (
          <button
            key={photo.id}
            type="button"
            className="og-album__shot"
            style={{ backgroundImage: `url(${photo.thumb_url || photo.url})` }}
            onClick={() => setIndex(i)}
            data-testid={`photo-${photo.id}`}
          >
            <span>
              {whenLabel(photo.taken_at)}
              {photo.gps_present ? "" : ` · ${ui.photos.noPlace}`}
            </span>
          </button>
        ))}
      </section>
      {!gallery.length ? <p className="og-hint">{ui.photos.empty}</p> : null}
      {index >= 0 ? (
        <PhotoLightbox items={gallery} index={index} onIndex={setIndex} onClose={() => setIndex(-1)} ui={ui} />
      ) : null}
    </main>
  );
}
